import { useState } from 'react';
import { MdEmail, MdPhone, MdLocationOn, MdAccessTime } from 'react-icons/md';
import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn } from 'react-icons/fa';
import { motion } from 'framer-motion';
import './Contact.css';

const CONTACT_INFO = [
  {
    icon: <MdEmail />,
    label: 'Email us',
    value: 'airrefund032@gmail.com',
    color: '#1e40af',
    bg: '#eff6ff',
  },
  {
    icon: <MdPhone />,
    label: 'Call us',
    value: '+44 7988 528 652',
    color: '#16a34a',
    bg: '#f0fdf4',
  },
  {
    icon: <MdLocationOn />,
    label: 'Our office',
    value: 'United Kingdom',
    color: '#1e40af',
    bg: '#eff6ff',
  },
  {
    icon: <MdAccessTime />,
    label: 'Working hours',
    value: '24 hours',

    color: '#16a34a',
    bg: '#f0fdf4',
  },
];

const SOCIALS = [
  { icon: <FaFacebookF />,  href: '#', label: 'Facebook' },
  { icon: <FaTwitter />,    href: '#', label: 'Twitter' },
  { icon: <FaInstagram />,  href: '#', label: 'Instagram' },
  { icon: <FaLinkedinIn />, href: '#', label: 'LinkedIn' },
];

const fadeUp = {
  hidden: { opacity: 0, y: 32 },
  show:   { opacity: 1, y: 0, transition: { duration: 0.55, ease: 'easeOut' } },
};
const stagger = {
  hidden: {},
  show:   { transition: { staggerChildren: 0.12 } },
};
const slideLeft = {
  hidden: { opacity: 0, x: -40 },
  show:   { opacity: 1, x: 0, transition: { duration: 0.6, ease: 'easeOut' } },
};
const slideRight = {
  hidden: { opacity: 0, x: 40 },
  show:   { opacity: 1, x: 0, transition: { duration: 0.6, ease: 'easeOut' } },
};

const vp = { once: true, amount: 0.2 };

export default function Contact() {
  const [form, setForm]       = useState({ name: '', email: '', subject: '', message: '' });
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent]       = useState(false);
  const [error, setError]     = useState(false);

  const handle = (e) => setForm(p => ({ ...p, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError(false);
    try {
      await fetch('https://formsubmit.co/ajax/airrefund032@gmail.com', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ ...form, _subject: 'New AirRefund Contact Message', _captcha: 'false' }),
      });
      setSent(true);
      setForm({ name: '', email: '', subject: '', message: '' });
    } catch (_) {
      setError(true);
    }
    setSubmitting(false);
  };

  const allFilled = form.name && form.email && form.subject && form.message;

  return (
    <div className="contact-page">

      {/* ── HERO ── */}
      <section className="contact-hero">
        <div className="contact-hero__overlay" />
        <motion.div
          className="contact-hero__content"
          initial="hidden" animate="show" variants={stagger}
        >
          <motion.span className="contact-tag" variants={fadeUp}>Get in touch</motion.span>
          <motion.h1 className="contact-hero__title" variants={fadeUp}>
            We're here to help<br /><span>every step of the way</span>
          </motion.h1>
          <motion.p className="contact-hero__sub" variants={fadeUp}>
            Have a question about your claim? Need help with a flight disruption?
            Our team is ready to assist you.
          </motion.p>
        </motion.div>
      </section>

      {/* ── MAIN SECTION ── */}
      <section className="contact-main">
        <div className="contact-main__inner">

          {/* LEFT — contact info */}
          <motion.div
            className="contact-info"
            initial="hidden" whileInView="show" viewport={vp} variants={slideLeft}
          >
            <h2 className="contact-info__title">Contact Us</h2>
            <p className="contact-info__sub">
             
            </p>

            <motion.div className="contact-info__list" variants={stagger} initial="hidden" whileInView="show" viewport={vp}>
              {CONTACT_INFO.map(({ icon, label, value, sub, color, bg }) => (
                <motion.div key={label} className="contact-info__item" variants={fadeUp}>
                  <div className="contact-info__icon" style={{ background: bg, color }}>
                    {icon}
                  </div>
                  <div className="contact-info__text">
                    <span className="contact-info__label">{label}</span>
                    <strong className="contact-info__value">{value}</strong>
                    <span className="contact-info__sub-text">{sub}</span>
                  </div>
                </motion.div>
              ))}
            </motion.div>

            {/* Socials */}
            <div className="contact-info__socials">
              <p>Follow us</p>
              <div className="contact-info__social-row">
                {SOCIALS.map(({ icon, href, label }) => (
                  <a key={label} href={href} className="contact-social-btn" aria-label={label}>
                    {icon}
                  </a>
                ))}
              </div>
            </div>

           
           
          </motion.div>

          {/* RIGHT — form */}
          <motion.div
            className="contact-form-wrap"
            initial="hidden" whileInView="show" viewport={vp} variants={slideRight}
          >
            {sent ? (
              <div className="contact-success">
                <div className="contact-success__icon">✅</div>
                <h3>Message sent!</h3>
                <p>Thanks for reaching out, <strong>{form.name || 'there'}</strong>. We'll get back to you within 24 hours at your email.</p>
                <button className="contact-btn" onClick={() => setSent(false)}>Send another message</button>
              </div>
            ) : (
              <form className="contact-form" onSubmit={handleSubmit} noValidate>
                <h3 className="contact-form__title">Send us a message</h3>
                <p className="contact-form__sub">Fill in the form below and we'll respond promptly.</p>

                <div className="contact-form__row">
                  <div className="cf-field">
                    <label>Full name</label>
                    <input name="name" value={form.name} onChange={handle} placeholder="Jane Doe" required />
                  </div>
                  <div className="cf-field">
                    <label>Email address</label>
                    <input type="email" name="email" value={form.email} onChange={handle} placeholder="jane@example.com" required />
                  </div>
                </div>

                <div className="cf-field">
                  <label>Subject</label>
                  <input name="subject" value={form.subject} onChange={handle} placeholder="e.g. Question about my claim" required />
                </div>

                <div className="cf-field">
                  <label>Message</label>
                  <textarea name="message" value={form.message} onChange={handle} placeholder="Tell us how we can help you..." rows={5} required />
                </div>

                {error && (
                  <p className="contact-form__error">Something went wrong. Please try again.</p>
                )}

                <button type="submit" className="contact-btn" disabled={submitting || !allFilled}>
                  {submitting
                    ? <><span className="contact-spinner" /> Sending…</>
                    : 'Send Message →'
                  }
                </button>
              </form>
            )}
          </motion.div>

        </div>
      </section>

    </div>
  );
}